function YoutubeIcon({ size = "24", color = "#b1272c" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 29.87 21.002"
    >
      <path
        id="Icon_awesome-youtube"
        data-name="Icon awesome-youtube"
        d="M30.3,7.786a3.753,3.753,0,0,0-2.641-2.658C25.325,4.5,15.985,4.5,15.985,4.5s-9.34,0-11.67.628A3.753,3.753,0,0,0,1.674,7.786a39.372,39.372,0,0,0-.624,7.236,39.372,39.372,0,0,0,.624,7.236,3.7,3.7,0,0,0,2.641,2.615c2.329.628,11.67.628,11.67.628s9.34,0,11.67-.628A3.7,3.7,0,0,0,30.3,22.258a39.372,39.372,0,0,0,.624-7.236A39.372,39.372,0,0,0,30.3,7.786ZM12.93,19.463V10.581l7.807,4.441L12.93,19.463Z"
        transform="translate(-1.05 -4.5)"
        fill={color}
      />
    </svg>
  );
}

export default YoutubeIcon;
